export default __webpack_public_path__ + "15dc5d2517db05dec99fcd562d639eef.png";